export default {
  SET_EVENTS: 'events/SET_EVENTS',
  SET_CALENDAR: 'events/SET_CALENDAR',
  enter: {
    INITIALIZE: 'event/enter/INITIALIZE',
    ADD_ENTRANT: 'event/enter/ADD_ENTRANT',
    ADJUST_ENTRANTS: 'event/enter/ADJUST_ENTRANTS',
    REPLACE_ENTRANT: 'event/enter/REPLACE_ENTRANT',
    UPDATE_ENTER: 'event/enter/REPLACE_ENTER',
  },
  gql: {
    GET_CALENDAR: `
      query GetEventsCalendar(
        $to: String!
        $from: String!
        $golfId: String!
        $reference: String
      ) {
        getEventsCalendar(
          to: $to
          from: $from
          golfId: $golfId
          reference: $reference
        ) {
          id
          name
          open
          openOnline
          endAt
          limit
          counter
          startAt
          lifecycle
          startDate
          partnerAllowed
          cancelableUntil
          alreadyRegistered
          options {
            id
            name
          }
          tournament {
            id
            name
            required
          }
        }
      }
    `,
    GET_EVENT: `
      query GetEvent(
        $id: String!
        $golfId: String!
        $reference: String
      ) {
        getEvent(
          id: $id
          golfId: $golfId
          reference: $reference
        ) {
          id
          name
          open
          openOnline
          endAt
          limit
          counter
          startAt
          lifecycle
          startDate
          partnerAllowed
          cancelableUntil
          alreadyRegistered
          options {
            id
            name
          }
          tournament {
            id
            name
            required
          }
        }
      }
    `,
    GET_ENTRY_FEES: `
      query GetEntryFees(
        $golfId: String!
        $eventId: String
        $players: [String]!
        $tournamentId: String
      ) {
        getEntryFees(
          golfId: $golfId
          eventId: $eventId
          players: $players
          tournamentId: $tournamentId
        ) {
          player
          entryFee
          greenFee
          events {
            id
            name
            required
            options {
              id
              name
              amount
              comment
            }
          }
        }
      }
    `,
    CHECK_ENTRY: `
      query CheckEntry(
        $golfId: String!
        $players: [EnterPlayerInput]!
      ) {
        checkEntry(
          golfId: $golfId
          players: $players
        ) {
          success
          message
        }
      }
    `,
    SET_ENTRY: `
      mutation SetEntry(
        $date: String!
        $golfId: String!
        $players: [EnterPlayerInput]!
        $payments: [EnterPaymentInput]!
        $comment: String
      ) {
        setEntry(
          date: $date
          golfId: $golfId
          players: $players
          payments: $payments
          comment: $comment
        ) {
          tid
          tournament {
            id
            bookingId
          }
          events {
            id
            bookingId
          }
        }
      }
    `,
    GET_ENTRY_LIST: `
      query GetEventEntryList(
        $id: String!
        $golfId: String!
      ) {
        getEventEntryList(
          id: $id
          golfId: $golfId
        ) {
          tid
          email
          owner
          option
          lastname
          partners
          firstname
          bookingId
        }
      }
    `,
    GET_MY_EVENTS: `
      query GetMyEvents(
        $golfId: String
      ) {
        getMyEvents(
          golfId: $golfId
        ) {
          id
          name
          status
          eventId
          startAt
          nbEntrants
          registeredAt
        }
      }
    `,
    GET_EVENT_ORDER: `
      query GetEventOrder($id: String!) {
        getEventOrder(id: $id) {
          id
          date
          comment
          eventEntrants {
            name
            option
            eventId
            bookingId
            price
            discount
            initPrice
          }
          tournamentEntrants {
            name
            slot
            greenFee
            entryFee
            bookingId
            tournamentId
            price
            discount
            initPrice
          }
          status {
            date
            status
          }
          total {
            price
            currency
          }
          payments {
            card
            amount
            callNo
            transactionNo
          }
          refunds {
            card
            date
            amount
            transactionNo
          }
          paymentMethod
        }
      }
    `,
    CANCEL_EVENT: `
      mutation CancelEvent($id: String!) {
        cancelEvent(id: $id) {
          status
        }
      }
    `,
  },
};
